/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  paper: Item<'Paper'>;
  paper1: Item<'Paper'>;
  horizontalSplitPanel: Item<'HorizontalSplitPanel'>;
} = {
  horizontalSplitPanel: {
    children: ['paper1', 'paper'],
    itemId: 'horizontalSplitPanel',
    parent: 'root',
    props: {},
    type: 'HorizontalSplitPanel',
  },
  paper: {
    children: [],
    itemId: 'paper',
    parent: 'horizontalSplitPanel',
    props: {},
    type: 'Paper',
  },
  paper1: {
    children: [],
    itemId: 'paper1',
    parent: 'horizontalSplitPanel',
    props: {},
    type: 'Paper',
  },
  root: {
    children: ['horizontalSplitPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      backgroundColor: 'default',
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};
